import { useQuery } from "@tanstack/react-query";
import { getUserGroup } from "../api/admin";
import { UserGroupParams } from "../types/types";

const useGetUserGroup = ({ group }: UserGroupParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["admin", `userGroup`, `group-${group}`],
    queryFn: () =>
      getUserGroup({
        group,
      }),

    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 0,
  });
  return { data, isLoading, isSuccess };
};

export default useGetUserGroup;
